/// <amd-module name="DRITools/DRIToolsHub/DRIToolsHub" />
import * as React from "react";

// VSS
import { IReadonlyObservableArray, ObservableValue } from "VSS/Core/Observable";
import { getTabs } from "VSS/Features/PlatformUI/ContributedTab";
import {
    Components,
    IVssComponentContext,
    VssComponent
} from "VSS/Platform/Layout";

// VSSUI
import {
    CustomHeader,
    HeaderTitle,
    HeaderTitleArea,
    HeaderTitleRow,
    TitleSize
} from "VSSUI/Header";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { IVssContributedTab, TabBar, TabContent } from "VSSUI/Tabs";

// DRITools
import * as Resources from "DRITools/DRIToolsHub/Resources";

class DRIToolsHub extends VssComponent<{}> {
    private c_defaultTab: string = "callgraph-tab";
    private c_driToolsTabGroupId: string =
        "ms.vss-dri-tools-web.dri-tools-hub-tab-group";

    private selectedTabId: ObservableValue<string>;
    private tabs: IReadonlyObservableArray<IVssContributedTab>;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this.tabs = getTabs(context.pageContext, this.c_driToolsTabGroupId);

        if (
            this.tabs.value &&
            this.tabs.value.find(x => x.id === this.c_defaultTab)
        ) {
            this.selectedTabId = new ObservableValue(this.c_defaultTab);
        } else if (this.tabs.value.length > 0) {
            const firstTabId = this.tabs.value[0].id;
            this.selectedTabId = new ObservableValue(firstTabId);
        }
    }

    public render(): JSX.Element {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page
                    className="flex-grow"
                    selectedTabId={this.selectedTabId}
                    tabProviders={this.tabs}
                >
                    <CustomHeader className="repos-commits-hub-header">
                        <div className="bolt-header-content-area flex-row flex-grow flex-self-stretch">
                            <HeaderTitleArea>
                                <HeaderTitleRow>
                                    <HeaderTitle titleSize={TitleSize.Large}>
                                        {Resources.DRIToolsHub_PageTitle}
                                    </HeaderTitle>
                                </HeaderTitleRow>
                            </HeaderTitleArea>
                        </div>
                    </CustomHeader>
                    <TabBar
                        selectedTabId={this.selectedTabId}
                        onSelectedTabChanged={this.onSelectedTabChanged}
                    />
                    <div className="page-content page-content-top flex-grow flex-column">
                        <TabContent />
                    </div>
                </Page>
            </Surface>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.selectedTabId.value = newTabId;
    };
}

Components.add("DRIToolsHub", DRIToolsHub);
